// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n95w","controls":"styles_controls__1xoas","charLimit":"styles_charLimit__3JETu","input":"styles_input__2OEev","send":"styles_send__3Sq9I"};